class LinkImage extends HTMLElement {
  constructor() {
    super();
    this.heading = this.querySelector(".rich-text__heading a");
    this.headingP = this.querySelector(".rich-text__heading");
    this.hoverImage = this.querySelector(".hover-image");
    this.clickedOnce = false;
    this.attachEventListeners();
  }

  attachEventListeners() {
    if (window.matchMedia("(max-width: 767px)").matches) {
      // Mobile devices - Hide the hover image
      this.hoverImage.style.display = "none";
    } else {
      // Desktop devices
      this.heading.addEventListener("mouseover", this.showImage.bind(this));
      this.heading.addEventListener("mouseout", this.hideImage.bind(this));
    }
  }

  handleMobileClick(event) {
    if (!this.clickedOnce) {
      event.preventDefault();
      this.showImage();
      this.clickedOnce = true;
    } else {
      // Proceed to the link
      window.location.href = this.heading.href;
    }
  }

  showImage() {
    document.querySelectorAll("link-image .hover-image").forEach((image) => {
      if (image !== this.hoverImage) {
        image.style.display = "none";
      }
    });
    this.hoverImage.style.display = "block";
    this.hoverImage.style.opacity = "0";
    this.hoverImage.style.transition = "opacity 0.5s";

    requestAnimationFrame(() => {
      this.hoverImage.style.opacity = "1";
    });
    this.heading.style.textDecoration = "underline";
    this.heading.style.textDecorationLine = "underline";
    this.heading.style.textDecorationThickness = "2px";

    this.heading.style.textDecorationColor = "black";
    this.heading.style.color = "black";
    this.heading.style.zIndex = "3";
    document
      .querySelectorAll(".rich-text__blocks .rich-text__heading a")
      .forEach((otherHeading) => {
        if (otherHeading !== this.heading) {
          otherHeading.style.color = "rgba(0, 0, 0, 0.3)";
          otherHeading.style.textDecoration = "none";
          otherHeading.style.zIndex = "1";
        }
      });
    document
      .querySelectorAll(".rich-text__blocks .rich-text__heading span")
      .forEach((otherSpan) => {
        otherSpan.style.color = "rgba(0, 0, 0, 0.3)";
      });
  }

  hideImage() {
    this.hoverImage.style.opacity = "0";
    this.hoverImage.addEventListener(
      "transitionend",
      () => {
        this.hoverImage.style.display = "none";
      },
      { once: true }
    );
    this.heading.style.textDecoration = "none";
    document
      .querySelectorAll(".rich-text__blocks .rich-text__heading a")
      .forEach((otherHeading) => {
        otherHeading.style.color = "black";
      });
    document
      .querySelectorAll(".rich-text__blocks .rich-text__heading span")
      .forEach((otherSpan) => {
        otherSpan.style.color = "black";
      });
    this.style.zIndex = "2";
  }
}

customElements.define("link-image", LinkImage);
